import React from "react";
import {SizedBox} from "../../../Global/Global";
import {Section} from "../Section";
import css from "../CreatePost.module.css";
import Space from "../../../Common/Space";
import Skeleton from "@mui/material/Skeleton";
import {Button, styled, TextField} from "@mui/material";
import {useMediaContext} from "../../../../MediaContext";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";


export const SkeletonZipField = () => {
    return (
        <div style={{display: "flex"}}>
            <Skeleton variant="rectangular" sx={{borderRadius: "4px"}}>
                <TextField fullWidth sx={{maxWidth: "5rem"}}/>
            </Skeleton>
            <SizedBox width="15px"/>
            <Skeleton variant="rectangular" sx={{borderRadius: "4px"}}>
                <TextField fullWidth sx={{maxWidth: "15rem"}}/>
            </Skeleton>
        </div>
    );
};

const SkeletonPriceField = () => {
    return (
        <Skeleton variant="rectangular" sx={{borderRadius: "4px"}}>
            <TextField fullWidth sx={{maxWidth: "10rem"}}/>
        </Skeleton>
    );
};

const SkeletonImageButton = () => {
    return (
        <Skeleton variant="rectangular" sx={{borderRadius: "4px"}}>
            <Button variant="contained" sx={{textTransform: "unset"}}>
                <label>Tilføj billeder</label>
            </Button>
        </Skeleton>
    )
}

const SkeletonSmallImage = () => <Skeleton
    variant="rectangular"
    style={{
        height: "8rem",
        width: "8rem",
        padding: "0.25rem",
        borderRadius: "4px",
        marginRight: "0.75rem",
        marginBottom: "0.75rem",
    }}
/>

const SkeletonLargeImage = () => <Skeleton variant="rectangular" sx={{
    borderRadius: "4px",
    height: "11rem",
    width: "11rem",
    minHeight: "11rem",
    minWidth: "11rem",
    padding: "0.25rem"
}}/>

const InfoIcon = styled(InfoOutlinedIcon)(({ theme }) => ({
    fontSize: "1em",
    verticalAlign: "middle",
    paddingBottom: "3px",
    paddingLeft: "4px",
    cursor: "pointer",
}));

const SkeletonTextField = () => {
    return (
        <Skeleton
            style={{
                width: "100%",
                maxWidth: "20rem",

                borderRadius: "4px",
            }}
            variant="rectangular"
        >
            <TextField fullWidth/>
        </Skeleton>
    );
};

const SkeletonImages = ({isUnderSm}) => (
    <div className={css.row} style={isUnderSm ? {display: "block"} : {}}>
        <SkeletonLargeImage/>
        <Space width="0.75rem" height="0.75rem"/>
        <div
            className={css.imgsContainer}
            style={isUnderSm ? {maxWidth: "20rem"} : {}}
        >
            <SkeletonSmallImage/>
            <SkeletonSmallImage/>
        </div>
    </div>
);

export const PostDetailSkeleton = () => {
    const mediaContext = useMediaContext();
    const isMobileSize = mediaContext.isMobileSize;

    return (
        <Section>
            <div style={{padding: "20px"}}>
                <div className={css.row} style={isMobileSize ? {display: "block"} : {}}>
                    {/* Column Left */}
                    <div className={css.column}>
                        <SkeletonTextField/>
                        <SizedBox height="15px"/>
                        <SkeletonTextField/>
                        <SizedBox height="15px"/>
                        <SkeletonTextField/>
                        <SizedBox height="15px"/>
                        <SkeletonTextField/>
                    </div>

                    <SizedBox width="15px" height="15px"/>

                    {/* Column Right */}
                    <div className={css.column}>
                        <SkeletonTextField/>
                        <SizedBox height="15px"/>
                        <SkeletonZipField/>
                        <SizedBox height="15px"/>
                        <SkeletonPriceField/>
                    </div>
                </div>
                <Space height="20px"/>
                <SkeletonImageButton/>
                <SizedBox height="15px"/>
                <SkeletonImages isUnderSm={isMobileSize}/>
            </div>
        </Section>
    );
};